import React from 'react';
import PropTypes from 'prop-types';
import Select from '@spothero/ui/select';

const SpotListSorter = ({sortBy, onChangeSort, sortSelectItems}) => {
    return (
        <div className="SpotListSorter">
            <Select
                defaultValue={sortBy}
                onChange={onChangeSort}
                items={sortSelectItems}
            />
        </div>
    );
};

SpotListSorter.propTypes = {
    sortBy: PropTypes.string,
    sortSelectItems: PropTypes.array,
    onChangeSort: PropTypes.func,
};

export default SpotListSorter;
